import { ProfilesList } from '../components/Profiles/List';

import { useDepartmentStore } from '@/stores/department';

export const Profiles = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <ProfilesList department={department} />;
};
